<template>
	<div>
		<table-run
			v-bind:columns="columns"
			v-bind:rows="rows"
			v-bind:selectable="false"
			v-bind:include-delete="false"
			v-bind:include-export-to-excel="false"
			v-bind:include-switch="false"
			v-bind:include-settings="false"
			v-bind:include-delete-single="false"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			class="no-selectable-table detail-table">
			<template slot="rows" scope="props">
				<td>
					<router-link
						:to="{ name: 'kardex', params: { productId: props.row.id,
						productName: props.row.name } }"
						class="to-kardex">
						{{ props.row.name }}
					</router-link>
				</td>
				<td>{{ props.row.price }}</td>
				<td>{{ props.row.quantity }}</td>
			</template>
		</table-run>
	</div>
</template>

<script>
	import TableRun from 'table-run';

	function columnSortableEvent({ id }) {
		this.$emit('sortable-list-detail', id);
	}

	function searchByColumn(search) {
		this.$emit('search-list-detail', search);
	}

	export default {
		components: {
			TableRun,
		},
		methods: {
			columnSortableEvent,
			searchByColumn,
		},
		name: 'list-of-details',
		props: {
			columns: {
				type: Array,
				required: true,
				default: [],
			},
			rows: {
				type: Array,
				required: true,
				default: [],
			},
		},
	};
</script>

<style lang="scss" scoped>
	.detail-table {
		border: 1px solid map-get($colors, default-bg);
	}

	.to-kardex {
		color: inherit;
		font-family: inherit;
	}
</style>



// WEBPACK FOOTER //
// ListOfDetails.vue?c3a621a2